var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIconBanner = function SvgCloseIconBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "close-icon-banner_svg__a",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "close-icon-banner_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close-icon-banner_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    mask: "url(#close-icon-banner_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.89 3.404.706.707-8.485 8.485-.707-.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.596 11.89-.707.706-8.485-8.485.707-.707z"
  })))));
};
export default SvgCloseIconBanner;